import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import LegalLayout from "../common/LegalLayout";
import SEOHead from "../SEO/SEOHead";
import "../../css/MainPage.css";

export default function PrivacyPolicy() {
  const sections = [
    {
      title: "1. Information We Collect",
      points: [
        "1.1 Personal Information: We may collect personal information that you voluntarily provide to us when you use our services, such as name, organization, company, email address, or phone number. If you register or sign up for marketing or newsletter emails for promotional purposes, then you are voluntarily doing so, and it is assumed you have given your consent to be added.",
        "1.2 Usage Data: We may also collect information about how you access and use our Website, including your IP address, browser type, pages visited, and time spent on our site."
      ]
    },
    {
      title: "2. How We Use Your Information",
      points: [
        "2.1 We may use the information we collect for various purposes, including to:",
        "• Provide, operate and maintain our services.",
        "• Process transactions and fulfill requests.",
        "• Communicate with you about our services and respond to inquiries.",
        "• Monitor, prevent and detect technical issues and security threats.",
        "• Develop new features and improve our Website.",
        "• Protect our rights and interests and enforce our Website’s terms."
      ]
    },
    {
      title: "3. Disclosure of Your Information",
      points: [
        "3.1 We may disclose your information to third parties, including:",
        "• Service providers who assist us in operating our Website or providing our services.",
        "• Law enforcement or government agencies in response to legal requests."
      ]
    },
    {
      title: "4. Data Security",
      points: [
        "4.1 We implement reasonable security measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security."
      ]
    },
    {
      title: "5. Your Choices",
      points: [
        "5.1 You may choose not to provide certain information, but this may limit your ability to use some features of our Website.",
        "5.2 You can opt out of receiving promotional communications from us by following the instructions in the emails or contacting us at info@roboticodigital.com."
      ]
    },
    {
      title: "6. Third-Party Links",
      points: [
        "6.1 Our Website may contain links to third-party websites or services that are not owned or controlled by us. We are not responsible for the privacy practices or content of these third-party sites."
      ]
    },
    {
      title: "7. Children’s Privacy",
      points: [
        "7.1 Our service is not directed to children under the age of 18, and we do not knowingly collect personal information from children. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us so we can delete the data."
      ]
    },
    {
      title: "8. Changes to This Policy",
      points: [
        "8.1 We may update this Privacy Policy from time to time. Any changes will be posted on this page. We encourage you to review this Privacy Policy periodically for updates."
      ]
    },
    {
      title: "9. Contact Us",
      points: [
        <>
          9.1 If you have any questions or concerns about this Privacy Policy, please write to us at{" "}
          <a href="mailto:info@roboticodigital.com" className="email-link">
            info@roboticodigital.com
          </a>
          {" "}or visit the <Link to="/contact">contact page</Link> for more details.
        </>
      ]
    },
    {
      title: "10. No Unsolicited Calls Policy",
      points: [
        "10.1 We value our users’ privacy and are committed to maintaining a phone-contact-free support communication approach. We will not initiate phone contact with individuals unless they have registered through our Website, signed application for employment opportunities, or shared a direct or indirect inquiry through our platform or channels."
      ]
    }
  ];

  return (
    <>
    <SEOHead
        title="Privacy Policy | Froth TestOps"
        description="Read the Froth TestOps Privacy Policy to understand how we collect, use, and protect your personal data when using our platform."
        keywords="Froth TestOps privacy policy"
      />
    <div className="fd-main-wrapper page-padding">
      <Header />
      <main>
        <LegalLayout
          crumbs="Privacy Policy"
          title="Privacy"
          highlight="Policy"
          lead="We respect your privacy. This policy explains what we collect, how we use it and the choices you have."
          sections={sections.map(s => ({ title: s.title, items: s.points }))}
        />
      </main>
      <Footer />
    </div>
    </>

  );
}